import(/* webpackMode: "eager" */ "/codebuild/output/src2703283910/src/intenlli-market-app/src/app/loading.tsx");
